import React from 'react'
import { Observable } from 'rx'
import type { BettingType } from '@mobi/betslip/types'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { trackBonusBetEvent } from '@core/Services/Analytics/helpers/trackers'
import { state$ as userState$ } from '@core/State/UserAccount/userAccountDriver'
import { QuickbetState, state$ as quickbetState$ } from '../../driver'
import { ToggleBonusCashUsage } from '../../signals'
import type { NotificationType } from '../Notifications/types'
import { Campaigns } from './Campaigns'

interface CampaignsStateProps {
  canBet: boolean
  bettingType: BettingType | null
  isUsingBonusBet: boolean
  isUsingBonusCash: boolean
  canConfirmBet: boolean
  accountNumber: number | null
  accountBalance: number | null
  bonusCashBalance: number | null
  bonusBetBalance: number | null
  notification: NotificationType | null
}

const state$ = Observable.combineLatest(
  quickbetState$,
  userState$,
  (quickbetState, userState): CampaignsStateProps => {
    const quickbetStateValue = quickbetState.toJS() as QuickbetState
    {
      return {
        canBet: quickbetStateValue.canBet,
        bettingType: quickbetStateValue.bettingType,
        isUsingBonusBet: quickbetStateValue.isUsingBonusBet,
        isUsingBonusCash: quickbetStateValue.isUsingBonusCash,
        canConfirmBet: quickbetStateValue.canConfirmBet,
        accountNumber: userState.accountNumber,
        accountBalance: userState.accountBalance,
        bonusCashBalance: userState.bonusCashBalance,
        bonusBetBalance: userState.bonusBetBalance,
        notification: quickbetStateValue.notificationType,
      }
    }
  }
)

export const QuickbetCampaigns: React.ComponentClass = observeImmutable(state$, ({ record }) => {
  const hasSuperPickError = record.notification === 'InvalidSuperPickSelection'
  return (
    <div data-testid='QuickbetCampaigns'>
      <Campaigns
        shouldDisplay={record.canBet && !record.isUsingBonusBet}
        bettingType={record.bettingType}
        handleRemoveBonusCashButtonClick={() => {
          ToggleBonusCashUsage(false)
          trackBonusBetEvent('quickbet-bonus-cash-removed', {
            accountBalance: record.accountBalance,
            accountNumber: record.accountNumber || '',
            bonusBetBalance: record.bonusBetBalance,
            bonusCashBalance: record.bonusCashBalance,
          })
        }}
        showRemoveButton={
          !hasSuperPickError &&
          !record.canConfirmBet &&
          (record.bettingType === 'fixed-odds-racing' ||
            record.bettingType === 'tote-racing' ||
            record.bettingType === 'mystery-quick-pick')
        }
      />
    </div>
  )
})
QuickbetCampaigns.displayName = 'QuickbetCampaigns'
